import { apiClient, type TruckTypeEntity, type PageEntity } from '@/libs/api'

export type TruckTypesRequestQuery = {
  name?: string
  enable?: boolean
  page?: number
  take?: number
}

export type FetchTruckTypesQuery = {
  tenantKey: string
  query?: TruckTypesRequestQuery
}

export type FetchTruckTypesResponse = {
  data: TruckTypeEntity[]
  pagination: PageEntity | null
}

// 車両属性一覧(車両属性マスタ一覧ページ用)を取得
export const fetchTruckTypesList = async (
  { tenantKey, query }: FetchTruckTypesQuery,
  signal?: AbortSignal
): Promise<FetchTruckTypesResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .truck_types.list.$get({
      query,
      config: { signal }
    })

  return { data, pagination }
}
